import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../css/mobileapp.css";
import logo1 from "../assets/logo.png";
import { FaArrowLeft, FaPaperPlane } from "react-icons/fa";

export default function MessagePage() {
  const navigate = useNavigate();

  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState("");

  const PAGE_PASSWORD = "tvk@2026"; // 🔐 change this

  // 🔐 CHECK PASSWORD ON LOAD
  useEffect(() => {
    const auth = sessionStorage.getItem("msg_auth");
    if (auth === "true") {
      setIsAuthenticated(true);
    }
  }, []);

  // 🔐 HANDLE LOGIN
  const handleLogin = () => {
    if (password === PAGE_PASSWORD) {
      sessionStorage.setItem("msg_auth", "true");
      setIsAuthenticated(true);
    } else {
      alert("Wrong Password ❌");
    }
  };

  // 🔥 SEND MESSAGE
  const handleSend = async () => {
    if (!message.trim()) {
      alert("Message empty!");
      return;
    }

    try {
      setLoading(true);

      const res = await fetch("https://tvk-backend-yl1b.onrender.com/api/messages", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          message: message,
          senderId: "admin",
          receiverId: "user1",
        }),
      });

      const data = await res.json();

      if (res.ok) {
        alert("Message sent ✅");
        setMessage("");
      } else {
        alert(data.error || "Failed to send");
      }
    } catch (err) {
      console.error(err);
      alert("Server error");
    } finally {
      setLoading(false);
    }
  };

  // 🔐 PASSWORD SCREEN
  if (!isAuthenticated) {
    return (
      <div className="mobile-container">
        <div className="message-container">
          <h2>🔐 Enter Password</h2>

          <input
            type="password"
            className="message-input"
            placeholder="Enter password..."
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <button className="send-btn" onClick={handleLogin}>
            Unlock
          </button>
        </div>
      </div>
    );
  }

  // 🔓 MAIN PAGE
  return (
    <div className="mobile-container">
      <div className="mobile-header">
        <button className="back-btn" onClick={() => navigate(-1)}>
          <FaArrowLeft />
        </button>

        <img src={logo1} alt="TVK Logo" className="mobile-logo" />
      </div>

      <div className="message-container">
        <h2> செய்தி அனுப்பு</h2>

        <textarea
          className="message-input"
          placeholder="உங்கள் செய்தியை எழுதுங்கள்..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />

        <button className="send-btn" onClick={handleSend} disabled={loading}>
          <FaPaperPlane /> {loading ? "Sending..." : "Send"}
        </button>
      </div>
    </div>
  );
}